/* Component containing the Schedule Scene data
 * Contains the ScheduleInfo component that contains each scenes 
   extra data
 * Contains the ScheduleCharacters component that contains
   each scene's characters and BG data */
import React, { useState } from 'react'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";
import ScheduleInfo from './ScheduleInfo';
import btnStyles from "../../../styles/Button.module.css";
import { Button, } from 'react-bootstrap';
import ScheduleCharacters from './ScheduleCharacters';

const ScheduleScene = (props) => {
    const [showInfo, setShowInfo] = useState(false);
    const [showInfoCast, setShowInfoCast] = useState(false);
    const {showSideBySide, scene, scene_id, style, next,
        filming_location, pages, end_time, day_order_number,
        start_time, number, int_ext, location } = props

    return (
        <div style={style} className={` ${styles.Bold}`} > 
        <div className='d-none d-md-block'>
            <Row className='py-1 text-center mx-0' >
                <Col className={`mx-0 px-0 d-flex-align-items-center ${styles.TitleBox2}`} xs={1} md={1}>
                <Button
                    className={`${btnStyles.Button} ${btnStyles.OrderN} py-0 px-3`}
                >
                    {day_order_number+1}
                </Button>
               </Col>
                <Col className={`mx-0 px-0  ${styles.TitleBox2}`} xs={1} md={1}>
                    <p className={`mb-0  ${styles.BoldScene}`}>{start_time}</p>
                </Col>
                <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={1} md={1}>
                    <p className='mb-0'>{number}</p>
                </Col>
                <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={4} md={4}>
                    <p style={{ textTransform: 'uppercase'}} className='mb-0'>{int_ext} {location}</p>
                </Col>
                <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={2} md={2}>
                <p className={`${styles.Rolexs}`}>{filming_location}</p>
                </Col>
                {/* showSideBySide  used when the add cast and schedule
                   are opened side by side style={{ fontStyle: 'italic'}}
                   className={`mb-0 ${styles.Div30M}`}*/}
                {showSideBySide ? (
                    <>
                    <Col xs={2} md={2} className={`mx-0 px-0 pb-1 ${styles.TitleBox2}`}>
                    <Button onClick={() => setShowInfoCast(showInfoCast => !showInfoCast)} 
                    className={`${btnStyles.Button} ${btnStyles.Shed}`}>
                    Cast
                    </Button>
                    </Col>
                    <Col className={`mx-0 px-0 `} xs={1} md={1}>
                    <Button onClick={() => setShowInfo(showInfo => !showInfo)} 
                        className={`${btnStyles.Button} ${btnStyles.Shed}`}>
                        I
                    </Button>
                    </Col>
                    </>
                ) : (
                    <>
                    <Col className={`mx-0 px-0 ${styles.TitleBox2}`}xs={1} md={1}>
                    <p >{pages}</p>
                    </Col>
                    <Col xs={1} md={1} className={`mx-0 px-0 pb-1 ${styles.TitleBox2}`}>
                    <Button onClick={() => setShowInfoCast(showInfoCast => !showInfoCast)} 
                    className={`${btnStyles.Button} ${btnStyles.Shed}`}>
                    Cast
                    </Button>
                    </Col>
                    <Col className={`mx-0 px-0 `} xs={1} md={1}>
                    <Button onClick={() => setShowInfo(showInfo => !showInfo)} 
                        className={`${btnStyles.Button} ${btnStyles.Shed}`}>
                        Info
                    </Button>
                    </Col>
                    </>
                ) }
            </Row>
            <Row>
                <Col>
                    {!showInfo ?("") : (                       
                    <ScheduleInfo
                    showSideBySide={showSideBySide}
                    style={style}
                    {...scene}/> 
                    ) }
                    {/* cast  */}
                    {!showInfoCast ?("") : (                       
                    <ScheduleCharacters 
                    style={style}
                    showSideBySide={showSideBySide}
                    scene_id={scene_id}
                    /> 
                    ) }
                </Col>
            </Row>
            {/* next */}
            {next ? (
            <Row className='px-3'>
                <Col className={`mb-0 py-2 ${styles.NextCall}`}>
                <p className="mb-0" >Next: {next} </p>
                </Col>
            </Row> 
            ) : ("") }     
        </div>
        {/* mobile */}
        <div className={`${styles.BottomScene} d-block d-md-none text-center mx-0`}>
            <Row className='text-center mx-0 px-0' >
                <Col className={`mx-0 px-0  ${styles.TitleBox2}`} xs={2}>
                    <p className={`mb-0  ${styles.BoldScene}`}>{start_time}</p>
                    <p className='mb-0'>{end_time}</p>
                </Col>
                <Col className={` mx-0 px-0 ${styles.TitleBox2}`} xs={8}>
                    <p style={{ textTransform: 'uppercase'}} className='mb-0'>{int_ext} {location}</p>
                    <hr className={`${styles.HrSched} my-0 mx-3`}></hr>
                    <div className={`${styles.Hig20}`}>
                    <p style={{ fontStyle: 'italic'}}
                   className={`mb-0 ${styles.Div30M}`}>{filming_location}</p>
                    </div>
                </Col>
                <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={2}>
                    <p className='mb-0'>{number}</p>
                </Col>
                </Row>
                <hr className={`${styles.HrSched} my-0 mx-3`}></hr>
                <Row className='my-1 mx-0 px-0 d-flex align-items-center '>
                <Col xs={2} className='mx-0 px-0 d-flex align-items-center justify-content-center' >
                <Button
                  className={`${btnStyles.Button} ${btnStyles.OrderNN} py-0 px-2`}
                >
                  {day_order_number+1}
                </Button>
                </Col>
                <Col className={`mx-0 pl-0 pr-2`} xs={4}>
                <Button onClick={() => setShowInfo((showInfo) => !showInfo)}
                className={`${btnStyles.Button} ${btnStyles.Shed} py-0 px-3`}
                >INFO
                </Button>
                </Col>
                <Col className={`mx-0 pr-0 pl-2 `} xs={4}>
                <Button onClick={() => setShowInfoCast(showInfoCast => !showInfoCast)}
                className={`${btnStyles.Button} ${btnStyles.Shed} py-0 px-3`}
                >CAST
                </Button>
                </Col>
               </Row>
            {/* info cast   */}
            <Row>
                <Col>
                    {!showInfo ?("") : (                       
                    <ScheduleInfo
                    style={style}
                    {...scene}/> 
                    ) }
                    {/* cast  */}
                    {!showInfoCast ?("") : (                       
                    <ScheduleCharacters 
                    style={style}
                    showSideBySide={showSideBySide}
                    scene_id={scene_id}
                    /> 
                    ) }
                </Col>
            </Row>
            {/* next */}
            {next ? (
                <Row>
                <Col className={`mb-0 py-2 ${styles.NextCall}`}>
                <p className="mb-0" >Next: {next} </p>
                </Col>
            </Row> 
            ) : (
                ""
            ) }     
        </div>
        </div>
    )
}

export default ScheduleScene